export const rubCurrencyOptions: Intl.NumberFormatOptions = {
  style: 'currency',
  currency: 'RUB',
};
